const THUMBNAIL_WIDTH = 320;
const FRAME_AT_SECONDS = 1;
const CAPTURE_TIMEOUT_MS = 5000;

/** One JPEG frame of a local video file, or null when the browser cannot decode it in time. */
export const captureVideoFrame = (file: File): Promise<Blob | null> =>
  new Promise((resolve) => {
    const url = URL.createObjectURL(file);
    const video = document.createElement('video');
    const finish = (frame: Blob | null) => {
      clearTimeout(timer);
      video.onloadedmetadata = null;
      video.onseeked = null;
      video.onerror = null;
      video.removeAttribute('src');
      video.load();
      URL.revokeObjectURL(url);
      resolve(frame);
    };
    const timer = setTimeout(() => finish(null), CAPTURE_TIMEOUT_MS);

    video.muted = true;
    video.onerror = () => finish(null);
    video.onloadedmetadata = () => {
      // MediaRecorder WebM files report an Infinity duration
      const { duration } = video;
      video.currentTime = Number.isFinite(duration) ? Math.min(FRAME_AT_SECONDS, duration / 2) : FRAME_AT_SECONDS;
    };
    video.onseeked = () => {
      const { videoWidth, videoHeight } = video;
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      if (!context || !videoWidth || !videoHeight) return finish(null);
      canvas.width = THUMBNAIL_WIDTH;
      canvas.height = Math.round((THUMBNAIL_WIDTH * videoHeight) / videoWidth);
      try {
        context.drawImage(video, 0, 0, canvas.width, canvas.height);
        canvas.toBlob(finish, 'image/jpeg', 0.8);
      } catch {
        finish(null);
      }
    };
    video.src = url;
  });
